module.exports = __webpack_public_path__ + "static/img/10.69adf628.jpg";